import React, { createContext, useContext, useState } from 'react';

// Define the type for the context value
interface RefreshPriceContextType {
  refreshPriceKey: number;
  setRefreshPriceKey: React.Dispatch<React.SetStateAction<number>>;
}

// Create the context with a default value
const RefreshPriceContext = createContext<RefreshPriceContextType | undefined>(undefined);

export const RefreshPriceProvider = ({ children }: { children: React.ReactNode }) => {
  const [refreshPriceKey, setRefreshPriceKey] = useState<number>(0);

  return (
    <RefreshPriceContext.Provider value={{ refreshPriceKey, setRefreshPriceKey }}>
      {children}
    </RefreshPriceContext.Provider>
  );
};

// Custom hook to use the context
export const useRefreshPrice = () => {
  const context = useContext(RefreshPriceContext);
  if (!context) {
    throw new Error('useRefreshPrice must be used within a RefreshPriceProvider');
  }
  return context;
};
